import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/subscribe")({
  head: () => buildRouteHead("/subscribe", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/en/subscribe", replace: true });
  },
});
